<script lang="ts">
	//Hooks
	import { beforeUpdate, createEventDispatcher } from 'svelte';
	//Design system components
	import { Slider } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let value: string | number = '0',
		title,
		disabled = false,
		min = 0;

	const dispatch = createEventDispatcher();

	const handle_change = (e) => {
		value = e.detail.value;
		dispatch('change', value);
	};
	beforeUpdate(() => {
		if (value === '101' || typeof value === 'undefined') {
			value = '0';
		}
	});
	const a11yProps = {
		sliderValueText: $format('current_brightness_value', {
			values: { value },
			default: `Current brightness value is ${value}`,
		}),
		ariaLabel: $format('collapse_title_brightness'),
		ariaLabelValue: $format('current_brightness_value', {
			values: { value },
			default: `Current brightness value is ${value}`,
		}),
	};
</script>

<Slider
	id="slider-714adxn"
	{a11yProps}
	{min}
	withOverlay={false}
	stopValueLabel
	{disabled}
	{title}
	on:value_change={handle_change}
	{value}
	type="horizontal"
/>
